import { styles } from './styles';

export const SortByPriorityDesc = (): JSX.Element => (
  <svg
    width="69"
    height="32"
    viewBox="0 0 69 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3C1 1.89543 1.89543 1 3 1H66C67.1046 1 68 1.89543 68 3V29C68 30.1046 67.1046 31 66 31H3C1.89543 31 1 30.1046 1 29V3Z"
      fill={styles.background}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0H66C67.6569 0 69 1.34315 69 3V29C69 30.6569 67.6569 32 66 32H3C1.34314 32 0 30.6569 0 29V3C0 1.34315 1.34315 0 3 0ZM3 1C1.89543 1 1 1.89543 1 3V29C1 30.1046 1.89543 31 3 31H66C67.1046 31 68 30.1046 68 29V3C68 1.89543 67.1046 1 66 1H3Z"
      fill={styles.border}
    />
    <path
      d="M4 5C4 3.89543 4.89543 3 6 3H63C64.1046 3 65 3.89543 65 5V6.77778C65 7.88235 64.1046 8.77778 63 8.77778H6C4.89543 8.77778 4 7.88235 4 6.77778V5Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 5.78191C14.5172 5.04325 15.116 4.44446 15.8547 4.44446H61.5591C62.2978 4.44446 62.8966 5.04325 62.8966 5.78191C62.8966 6.52056 62.2978 7.11935 61.5591 7.11935H15.8547C15.116 7.11935 14.5172 6.52056 14.5172 5.78191Z"
      fill={styles.background}
    />
    <path
      d="M4 11.7407C4 10.6362 4.89543 9.74072 6 9.74072H63C64.1046 9.74072 65 10.6362 65 11.7407V13.5185C65 14.6231 64.1046 15.5185 63 15.5185H6C4.89543 15.5185 4 14.6231 4 13.5185V11.7407Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 12.5226C14.5172 11.784 15.116 11.1852 15.8547 11.1852H61.5591C62.2978 11.1852 62.8966 11.784 62.8966 12.5226C62.8966 13.2613 62.2978 13.8601 61.5591 13.8601H15.8547C15.116 13.8601 14.5172 13.2613 14.5172 12.5226Z"
      fill={styles.background}
    />
    <path
      d="M4 18.4814C4 17.3769 4.89543 16.4814 6 16.4814H63C64.1046 16.4814 65 17.3769 65 18.4814V20.2592C65 21.3638 64.1046 22.2592 63 22.2592H6C4.89543 22.2592 4 21.3638 4 20.2592V18.4814Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 19.2634C14.5172 18.5247 15.116 17.9259 15.8547 17.9259H61.5591C62.2978 17.9259 62.8966 18.5247 62.8966 19.2634C62.8966 20.002 62.2978 20.6008 61.5591 20.6008H15.8547C15.116 20.6008 14.5172 20.002 14.5172 19.2634Z"
      fill={styles.background}
    />
    <path
      d="M4 25.2222C4 24.1176 4.89543 23.2222 6 23.2222H63C64.1046 23.2222 65 24.1176 65 25.2222V26.9999C65 28.1045 64.1046 28.9999 63 28.9999H6C4.89543 28.9999 4 28.1045 4 26.9999V25.2222Z"
      fill={styles.element}
    />
    <path
      d="M14.5172 26.0041C14.5172 25.2654 15.116 24.6666 15.8547 24.6666H61.5591C62.2978 24.6666 62.8966 25.2654 62.8966 26.0041C62.8966 26.7427 62.2978 27.3415 61.5591 27.3415H15.8547C15.116 27.3415 14.5172 26.7427 14.5172 26.0041Z"
      fill={styles.background}
    />
    <path
      d="M13 26.0016C13 25.2643 12.4023 24.6666 11.665 24.6666H7.335C6.5977 24.6666 6 25.2643 6 26.0016C6 26.7389 6.5977 27.3366 7.335 27.3366H11.665C12.4023 27.3366 13 26.7389 13 26.0016Z"
      fill={styles.highlight}
    />
  </svg>
);
